import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Box,
  Image,
  Spinner,
  Checkbox,
  RadioGroup,
  Radio,
} from "@chakra-ui/react";
import thelogo from "../../../assets/thelogo.png"
import { getFollowingUsers } from "../../../pages/dashboard/discover/service";

const ChangeGroupRoleModal = ({ isOpen, onClose, authUserId, groupData, myMembers, handleChangeMemberRole }) => {
  //sconsole.log("userid-->", authUserId);

  const [allFollowers, setAllFollowers] = useState([]); //unused
  const [loading, setLoading] = useState(true); //unused
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedSingleUser, setSelectedSingleUser] = useState([]);

  const [valueOption, setValueOption] = useState('member')

  const containerBgColor = useColorModeValue("#fff", "#000216");
  const inputBgColor = useColorModeValue("#F9FAFC", "rgba(6, 119, 232, 0.2)"); 

  const inputStyles = {
    p: "5px",
    borderRadius: "5px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    color: "rgba(6, 119, 232, 1)",
    w: "15%",
    //color: "#697C94",
    // h: "2em"
  };

  const selectInputStyles = {
    p: "5px",
    borderRadius: "5px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    color: "rgba(6, 119, 232, 1)",
    w: "15%",
    //color: "#697C94",
    // h: "2em"
  };

  const btnStyle = {
    p: "5px 10px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
    w: "30%",
  };

  // Create a function to handle checkbox changes
  const handleCheckboxChange = (userId) => {
    if (selectedUsers.includes(userId)) {
      // If the user is already selected, remove them
      setSelectedUsers(selectedUsers.filter((id) => id !== userId));
    } else {
      // If the user is not selected, add them
      setSelectedUsers([...selectedUsers, userId]);
    }

  };

  //console.log('selectedUsers: ', selectedUsers)

  const handleMultipleUsers = (selectedUsers) => {
    handleChangeMemberRole(selectedUsers)
  };

  const handleSingleUser = (userId) => {
    const userIdArray = [userId]
    console.log('userIdArray: ', userIdArray);
    handleChangeMemberRole(userIdArray)
  };

  return (
    <>
    
    <Modal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside">
      
        <ModalOverlay />
        <ModalContent bg={containerBgColor}>
          <ModalHeader>
            
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          <Flex justifyContent="center" alignItems="center" mb={"2em"}>
            <Heading fontSize={"1.5em"}>Change Members Status in {groupData?.name}</Heading>
          </Flex>

          <Flex justifyContent="center" alignItems="center" mb={"2em"}>
          <RadioGroup defaultValue='member' name="form-name" onChange={setValueOption} value={valueOption}>
            <Stack spacing={5} direction='row'>
                <Radio value='member'>As Member</Radio>
                <Radio value='moderator'>As Moderator</Radio>
            </Stack>
          </RadioGroup>

            <Select
                display={"none"}
                fontSize={".9em"}
                name="category"
                //onChange={handleChange}
                _placeholder={{ color: "#f2f2f2" }}
                //{...selectInputStyles}
                //w={"100%"}
                p={"0.5px !important"}
                w={"50% !important"}
                bg={"#fff !important"}
                boxShadow="none"
                defaultValue={"default"}
            >
                <option disabled value="default" color="#fff">
                Choose Status
                </option>
                <option key="1" value="member" style={{ color: "#718096" }}></option>
                <option key="2" value="moderator" style={{ color: "#718096" }}></option>
            </Select>
          </Flex>
          
          {myMembers?.length > 0 ? 
          (myMembers?.map((user, index) => (
            <Flex justifyContent="space-between" alignItems="center" mb={"2em"} key={index}>
                <Stack>
                {/* Content for the left side */}
                {/* <Checkbox
                    value={user?.id}
                    onChange={() => handleCheckboxChange(user?.id)} // Handle checkbox change
                    isChecked={selectedUsers.includes(user?.id)} // Check if the checkbox is checked
                > */}
                    <Flex alignItems="center">
                
                        <Image
                            fallbackSrc={thelogo} // Provide a fallback image source
                            src={user?.picture} // Replace with the actual image source
                            alt={user?.name} // Replace with the actual alt text
                            boxSize="50px"
                            borderRadius="50%"
                        />
                        <Text ml="2">{user?.name}</Text>
                
                    </Flex>
                {/* </Checkbox> */}
                </Stack>

                <Box
                  textAlign={"center"}
                  {...inputStyles}
                  cursor={"pointer"}
                  onClick={() => handleSingleUser(user?.id)}
                >
                    Member
                </Box>
            </Flex>

            
          ))) : (
            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
                <Spinner size="xl" color="blue.500" />
            </Flex>
            
          )
        }

            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
              <Button
                display={"none"}
                bg="#07900C"
                {...btnStyle}
                disabled={selectedUsers?.length === 0} // Disable the button when no users are selected
                onClick={() => handleMultipleUsers(selectedUsers)}
              >
                Submit
              </Button>
            </Flex>

          </ModalBody>
        </ModalContent>
    </Modal>
    
    </>
  )
}

export default ChangeGroupRoleModal